import RiskReward from '../RiskReward';
import { getRiskStatus, getFormattedDescription } from '../../utils';
import type { CompanySubSection } from '@/pages/CompanyReport/hooks/useReportUrlHandler';
import If from '@/components/If';
import type { GroupRisks } from '../../types';
import { useOverviewTranslation } from '@/pages/CompanyReport/components/OverviewSection/hooks/useOverviewTranslation';

interface Props {
  risks: GroupRisks;
  tickerSymbol?: string;
}

const RiskSummaryList = ({ risks, tickerSymbol }: Props) => {
  const totalFailingRisksToDisplay = 4;
  const failingRisksList = [...risks.failRisksMayor, ...risks.failRisksMinor];
  const displayFailingRisksList = failingRisksList.slice(
    0,
    totalFailingRisksToDisplay
  );
  const totalRisksNotDisplayed =
    failingRisksList.length - displayFailingRisksList.length;
  const summaryRiskStatus = getRiskStatus(risks);

  const t = useOverviewTranslation();

  return (
    <If
      conditions={{
        hasPassedAllRisks: summaryRiskStatus === 'hasPassedAllRisks',
        hasNotFailedAnyRisk: summaryRiskStatus === 'hasNotFailedAnyRisk',
        InsufficientData: summaryRiskStatus === 'insufficientData',
        hasFailedRisks: summaryRiskStatus === 'hasFailedRisks',
      }}
    >
      {{
        hasPassedAllRisks: () => (
          <p>{t('risks.hasPassedAllRisks', { tickerSymbol })}</p>
        ),
        hasNotFailedAnyRisk: () => (
          <p>{t('risks.hasNotFailedAnyRisk', { tickerSymbol })}</p>
        ),
        insufficientData: () => <p>{t('risks.insufficientData')}</p>,
        hasFailedRisks: () => (
          <>
            {displayFailingRisksList.map((risk, i) => {
              const formattedDescription = getFormattedDescription(
                risk.description
              );
              return (
                <RiskReward
                  name={risk.name}
                  key={risk.name}
                  index={i}
                  severity={risk.severity}
                  description={formattedDescription}
                  hash={risk.hash?.replace('#', '') as CompanySubSection}
                />
              );
            })}
            {failingRisksList.length > totalFailingRisksToDisplay ? (
              <p>
                {t('risks.hasFailedRisks', { count: totalRisksNotDisplayed })}
              </p>
            ) : (
              <br />
            )}
          </>
        ),
      }}
    </If>
  );
};

export default RiskSummaryList;
